module.exports = __webpack_public_path__ + "img/game_pc_th.b5fbd6e6.png";